import {imageBaseUrl} from "../redux/apis/api";

export const hajjContent = 'hajj_content';
export const islamicLifeStyle = 'islamic_life_style';
export const islamicHistory = 'islamic_history';
export const namajLearning = 'namaj_learning';
export const isAdult = 'is_adult';
export const isSeniorCitizen = 'is_senior_citizen';
export const isChildhood = 'is_childhood';
export const isTeen = 'is_teen';
export const oneToMany = 'one_to_many';
export const oneToOne = 'one_to_one';
export const logo = imageBaseUrl + 'web_assets/logo-1583391444-8858931.png';
export const brandLogo = imageBaseUrl + 'web_assets/brandLogo-1587544578-5162420.png';
export const dataNotFound = imageBaseUrl + 'web_assets/data_not_found-1583753721-5556394.png';
export const digitalQuran = imageBaseUrl + 'web_assets/Digital_Quran-1583392326-4107576.svg';
export const avater = imageBaseUrl + 'web_assets/user-avatar-1584014317-6555553.svg';
export const teacherImg1 = imageBaseUrl + 'web_assets/teacher_img_1-1584250414-4544432.png';
export const userProfilePic = imageBaseUrl + 'web_assets/userProfilePic-1584260797-8006344.jpg';
export const myCoursesLogo = imageBaseUrl + 'web_assets/myCoursesLogo-1584274847-1450072.png';
export const onDemandRegularPrice = '89.99';
export const onDemandRegularOfferPrice = '11.99';
